import { formatMoney, money, sum, type Money } from '@budget/core';
import { useCurrency } from '../features/currency/currency-context.js';
import { SyncStatusPanel } from '../features/sync/SyncStatusPanel.js';

/**
 * The dashboard is phase 2 work. What is wired up here is the one thing phase 1
 * has to prove end to end: amounts in several currencies, converted and
 * formatted through the shared FX path the whole app will use.
 */
export function DashboardPage() {
  const { displayCurrency, tryConvert, fxStatus } = useCurrency();

  // Placeholder holdings until the portfolio query lands in phase 2.
  const holdings: Money[] = [money('0', 'EUR')];

  const converted = holdings.map((holding) => tryConvert(holding));
  // A total that silently drops the amounts it could not convert understates
  // net worth, which is the one number that must never be quietly wrong.
  const missing = converted.filter((value) => value === null).length;
  const total = missing === 0 ? sum(converted as Money[], displayCurrency) : null;

  return (
    <div className="stack">
      <section className="card">
        <h1 className="card__title">Összes vagyon</h1>
        <p className="figure" data-testid="total-wealth">
          {total ? formatMoney(total) : '—'}
        </p>
        <p className="muted">{describeState(fxStatus, missing)}</p>
      </section>

      <SyncStatusPanel />
    </div>
  );
}

function describeState(fxStatus: string, missing: number): string {
  if (fxStatus === 'loading') return 'Árfolyamok betöltése…';
  if (fxStatus === 'error') return 'Nem sikerült betölteni az árfolyamokat.';
  if (missing > 0) {
    return `${missing} tétel árfolyama hiányzik — futtasd az fx-sync jobot.`;
  }
  return 'A bontás és az eszközosztályok a 2. fázisban jelennek meg.';
}
